import { get, uri } from "api/BaseApi";
import { TextileVariant } from "./fetchTextileVariants";

export const getSelectedTextileVariant = (id: number): Promise<TextileVariant> => {
  return get('/textile_orders/' + uri(id) + '/selected_textile_variant');
}
